import { Form, Button } from "react-bootstrap";

export default function PeriodFilter({
  label = "Periode",
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
  onSubmit,
  submitLabel = "Tampilkan",
  disabled = false,
}) {
  return (
    <div className="period-filter w-100">
      <Form.Label className="text-white mb-1">
        {label}
      </Form.Label>

      <div className="d-flex flex-wrap flex-sm-nowrap gap-2">
        <Form.Control
          type="date"
          value={startDate}
          onChange={(e) => onChangeStart(e.target.value)}
        />

        <Form.Control
          type="date"
          value={endDate}
          onChange={(e) => onChangeEnd(e.target.value)}
        />

        <Button
          variant="success"
          disabled={disabled}
          onClick={onSubmit}
        >
          {submitLabel}
        </Button>
      </div>
    </div>
  );
}
